import React, { Component } from "react";
import AuthService from "../services/auth.service";
import { Navbar, Nav,Container} from "react-bootstrap";

// https://react-bootstrap.github.io/components/navs/
// https://stackoverflow.com/questions/62721457/react-bootstrap-change-link-of-navbar-to-active

export default class Profile extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentUser: AuthService.getCurrentUser()
    };
  }

  logOut() {
    AuthService.logout();
  }

  render() {
    const { currentUser } = this.state;
    

    return (
    <div className="navigation">
    <Navbar bg="" expand="lg">
      <Container>
        {/* <Navbar.Brand href="/">Homepage</Navbar.Brand> */}
        <Navbar.Toggle aria-controls="basic-navbar-nav" className="ms-auto" />
        <Navbar.Collapse id="basic-navbar-nav">

            {currentUser ? (
              <Nav className="ms-auto" as="ul" activeKey={window.location.pathname}>
                <Nav.Item as="li">
                  <Nav.Link href="/help" >Help</Nav.Link>
                </Nav.Item>
                <Nav.Item as="li">
                  <Nav.Link href="/profile" >My account</Nav.Link>
                </Nav.Item>
                <Nav.Item as="li">
                  <Nav.Link href="/login" onClick={this.logOut} >Logout</Nav.Link>
                </Nav.Item>
              </Nav>
            ) : (
              <Nav className="ms-auto" as="ul" activeKey={window.location.pathname}>
                <Nav.Item as="li">
                  <Nav.Link href="/category/0" >Help</Nav.Link>
                </Nav.Item>
                <Nav.Item as="li">
                  <Nav.Link href="/login" >Login</Nav.Link>
                </Nav.Item>
              </Nav>
            )}
              
            
          
        </Navbar.Collapse>
      </Container>
    </Navbar>
    </div>
  );
  }
}
